var FontWeights = /* @__PURE__ */ ((FontWeights2) => {
  FontWeights2[FontWeights2["HEAVY"] = 900] = "HEAVY";
  FontWeights2[FontWeights2["EXTRABOLD"] = 800] = "EXTRABOLD";
  FontWeights2[FontWeights2["BOLD"] = 700] = "BOLD";
  FontWeights2[FontWeights2["SEMI"] = 600] = "SEMI";
  FontWeights2[FontWeights2["MEDIUM"] = 500] = "MEDIUM";
  FontWeights2[FontWeights2["NORMAL"] = 400] = "NORMAL";
  FontWeights2[FontWeights2["LIGHT"] = 300] = "LIGHT";
  return FontWeights2;
})(FontWeights || {});
const displayFontFamily = "Satoshi, Open Sans, Avenir";
const webTextStyles = {
  largeTitle: {
    lineHeight: "41px"
  },
  title1: {
    lineHeight: "34px",
    letterSpacing: 0.18
  },
  title2: {
    lineHeight: "28px",
    letterSpacing: 0.15
  },
  title3: {
    lineHeight: "25px",
    letterSpacing: 0.15
  },
  headline: {
    lineHeight: "22px",
    letterSpacing: 0.15
  },
  body: {
    lineHeight: "22px",
    letterSpacing: -0.3
  },
  callout: {
    lineHeight: "21px",
    letterSpacing: -0.3
  },
  subHead: {
    lineHeight: "20px",
    letterSpacing: -0.3
  },
  footnote: {
    lineHeight: "18px",
    letterSpacing: -0.15
  },
  caption1: {
    lineHeight: "16px"
  },
  caption2: {
    lineHeight: "13px"
  },
  navigation: {
    lineHeight: "10px"
  }
};
const displayTextStyles = {
  xLargeDisplay: {
    lineHeight: "84px",
    letterSpacing: -1.5
  },
  largeDisplay: {
    lineHeight: "74px",
    letterSpacing: -1
  },
  largeCTA: {
    lineHeight: "42px"
  },
  mediumCTA: {
    lineHeight: "30px"
  },
  largeTitle: {
    lineHeight: "24px"
  },
  mediumTitle: {
    lineHeight: "22px"
  },
  smallTitle: {
    lineHeight: "22px"
  },
  largeButton: {
    lineHeight: "16px"
  },
  mediumButton: {
    lineHeight: "14px"
  },
  smallButton: {
    lineHeight: "12px"
  }
};
const displayWebTextStyes = {
  displayLarge: {
    lineHeight: "82px"
  },
  displayRegular: {
    lineHeight: "72px"
  },
  headlineLarge: {
    lineHeight: "57px"
  },
  headlineMedium: {
    lineHeight: "47px"
  },
  headlineSmall: {
    lineHeight: "37px"
  },
  subHeadBoldLarge: {
    lineHeight: "37px"
  },
  subHeadRegularLarge: {
    lineHeight: "42px"
  },
  subHeadSmall: {
    lineHeight: "27px"
  },
  bodyRegular: {
    lineHeight: "28px"
  },
  bodyDisclaimer: {
    lineHeight: "22px"
  },
  ctaButtonText: {
    lineHeight: "28px"
  },
  textLinkStandard: {
    lineHeight: "28px",
    textDecorationLine: "underline"
  },
  textLinkDisclaimer: {
    lineHeight: "22px",
    textDecorationLine: "underline"
  }
};
var Palette = /* @__PURE__ */ ((Palette2) => {
  Palette2["BLACK"] = "#000000";
  Palette2["DARKER_GRAY"] = "#303030";
  Palette2["DARK_GRAY"] = "#767676";
  Palette2["GRAY"] = "#AEAEAE";
  Palette2["LIGHT_GRAY"] = "#E8E8E8";
  Palette2["BACKGROUND"] = "#F4F4F4";
  Palette2["WHITE"] = "#FFFFFF";
  Palette2["DARKER_PURPLE"] = "#271B3C";
  Palette2["DARK_PURPLE"] = "#382757";
  Palette2["DARK_PURPLE_TRANSPARENT"] = "#382757D6";
  Palette2["DARK_PURPLE_LIGHTER_TRANSPARENT"] = "#3827571A";
  Palette2["DARKER_VIOLET"] = "#7027B9";
  Palette2["VIOLET"] = "#8333D4";
  Palette2["VIOLET_TRANSPARENT"] = "#8333D466";
  Palette2["VIOLET_LIGHT_TRANSPARENT"] = "#8333D41A";
  Palette2["VIOLET_LIGHTER_TRANSPARENT"] = "#8333D40D";
  Palette2["LIGHT_VIOLET"] = "#BB86FC";
  Palette2["LIGHT_VIOLET_TRANSPARENT"] = "#BB86FC80";
  Palette2["DARK_GREEN"] = "#00804A";
  Palette2["GREEN"] = "#29D3A2";
  Palette2["GREEN_TRANSPARENT"] = "#29D3A21A";
  Palette2["RED"] = "#BD0013";
  Palette2["RED_TRANSPARENT"] = "#BD001314";
  Palette2["RED_LIGHTER_TRANSPARENT"] = "#BD001308";
  Palette2["FPO_MAGENTA"] = "#FF00FF";
  Palette2["FUSCHIA"] = "#CE5DCB";
  Palette2["PLUM"] = "#D39BD3";
  Palette2["WATERMELON"] = "#FF5667";
  Palette2["WATERMELON_TRANSPARENT"] = "#FF56671A";
  Palette2["CORAL"] = "#F08570";
  Palette2["AZALEA"] = "#F9B5B2";
  Palette2["AZALEA_TRANSPARENT"] = "#F9B5B266";
  Palette2["AZALEA_LIGHT_TRANSPARENT"] = "#F9B5B240";
  Palette2["AZALEA_LIGHTER_TRANSPARENT"] = "#F9B5B21A";
  Palette2["DARK_ORANGE"] = "#D14507";
  Palette2["ORANGE"] = "#FF8100";
  Palette2["TANGERINE"] = "#FEA500";
  Palette2["TANGERINE_TRANSPARENT"] = "#FEA5001A";
  Palette2["APRICOT"] = "#FCD7B6";
  Palette2["JADE"] = "#00B874";
  Palette2["SEAFOAM"] = "#9FF4D9";
  Palette2["DARK_GOLD"] = "#C78500";
  Palette2["PREMIUM_GOLD"] = "#EBB551";
  Palette2["PREMIUM_GOLD_TRANSPARENT"] = "#EBB55180";
  Palette2["LIGHT_GOLD"] = "#FEE4A4";
  Palette2["PREMIUM_LIGHT_YELLOW"] = "#FFFCF6";
  Palette2["SUNBURN"] = "#C14F24";
  Palette2["ALERT_SUCCESS"] = "#2D4929";
  Palette2["ALERT_INFO"] = "#1A425E";
  Palette2["ALERT_WARNING"] = "#634215";
  Palette2["ALERT_ERROR"] = "#582522";
  Palette2["ALERT_SUCCESS_LIGHTER"] = "#EFF7EE";
  Palette2["ALERT_INFO_LIGHTER"] = "#E8F5FC";
  Palette2["ALERT_WARNING_LIGHTER"] = "#FDF4E7";
  Palette2["ALERT_ERROR_LIGHTER"] = "#FAEEED";
  return Palette2;
})(Palette || {});
var Effects = /* @__PURE__ */ ((Effects2) => {
  Effects2["DROP_SHADOW"] = `0px 2px 5px 0px rgba(0, 0, 0, 0.2)`;
  Effects2["DROP_SHADOW_OVERLAY"] = `0px 2px 5px 0px rgba(0, 0, 0, 0.4)`;
  Effects2["DROP_SHADOW_LIGHT"] = `0px 2px 5px 0px rgba(0, 0, 0, 0.1)`;
  return Effects2;
})(Effects || {});
export {
  Effects,
  FontWeights,
  Palette,
  displayFontFamily,
  displayTextStyles,
  displayWebTextStyes,
  webTextStyles
};
//# sourceMappingURL=constants.js.map
